import { Component, EventEmitter, Output } from '@angular/core';
import { Language } from '../../../domain/models';
import { LanguagesService } from '../../../domain/services/languages.service';

@Component({
    selector: 'app-preferred-language',
    templateUrl: './preferred-language.component.html',
    styleUrls: ['./preferred-language.component.scss'],
    standalone: false
})
export class PreferredLanguageComponent {
    @Output() language = new EventEmitter<Language>();

    languages$ = this._languages.languages$;

    constructor(private readonly _languages: LanguagesService) {}

    chooseLanguage(language: Language) {
        this.language.next(language);
    }
}
